import { createContext, useContext, useState } from "react";
import translations from "@/constants/translations";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem('sb_lang') || 'id');
  const [currency, setCurrency] = useState(() => localStorage.getItem('sb_currency') || 'IDR');

  const handleSetLanguage = (lang) => { setLanguage(lang); localStorage.setItem('sb_lang', lang); };
  const handleSetCurrency = (curr) => { setCurrency(curr); localStorage.setItem('sb_currency', curr); };

  const t = (key) => translations[language]?.[key] ?? translations.en?.[key] ?? key;

  const formatAmount = (amount, curr = currency) => {
    const num = Number(amount) || 0;
    if (curr === 'IDR') {
      return `Rp ${num.toLocaleString('id-ID')}`;
    }
    return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  return (
    <AppContext.Provider value={{ language, setLanguage: handleSetLanguage, currency, setCurrency: handleSetCurrency, t, formatAmount }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
export default AppContext;
